export default "__VITE_ASSET__CFKhV2Cb__"